import Tray from './tray';
import TrayButton from './tray-button';
import TrayClose from './tray-close';
import TrayMenu from './tray-menu';
import TrayTitle from './tray-title';

export {
  Tray,
  TrayButton,
  TrayClose,
  TrayMenu,
  TrayTitle
};

export default TrayMenu;
